var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg9Tablet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 732,
    viewBox: "0 0 770 732",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_454_109810)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.564,
    cy: 386.579,
    rx: 267.564,
    ry: 386.579,
    transform: "matrix(0.597199 0.802093 -0.989927 0.141579 617.977 467.668)",
    fill: "url(#paint0_linear_454_109810)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_454_109810)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.564,
    cy: 386.579,
    rx: 267.564,
    ry: 386.579,
    transform: "matrix(0.597199 0.802093 -0.989927 0.141579 854.812 291)",
    fill: "url(#paint1_linear_454_109810)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_454_109810",
    x: -199.734,
    y: 335.477,
    width: 1189.62,
    height: 803.068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_454_109810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_454_109810",
    x: -62.8984,
    y: 58.8086,
    width: 1389.62,
    height: 1003.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 140,
    result: "effect1_foregroundBlur_454_109810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_109810",
    x1: 267.564,
    y1: 0,
    x2: 267.564,
    y2: 773.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_454_109810",
    x1: 267.564,
    y1: 0,
    x2: 267.564,
    y2: 773.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg9Tablet);
export default __webpack_public_path__ + "static/media/bg9-tablet.1fd95bc4e630987c2cbcf0539f6cd294.svg";
export { ForwardRef as ReactComponent };